<template>
  <div>deliveryPeriodStart</div>
</template>
<script>
export default {
  name: 'deliveryPeriodStart',
}
</script>
